import React from 'react'
import { ICONS } from '@Const/common'
import './index.scss'

interface NeedsAttentionTabHeaderProps {
    needsAttentionCount?: number
}

const NeedsAttentionTabHeader = ({ needsAttentionCount }: NeedsAttentionTabHeaderProps) => {
    if (needsAttentionCount) {
        return (
            <span className="needs-attention-header">
                <img src={ICONS.error} alt="error" className="error-icon" />
                <strong>Needs Attention ({needsAttentionCount})</strong>
            </span>
        )
    } else {
        return <strong>Needs Attention</strong>
    }
}

export default NeedsAttentionTabHeader
